"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
const ErrorPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(4.000000, 3.000000)"
}, _react.default.createElement("path", {
  d: "M2.6912,19.9585 L12.0002,3.0355 L21.3082,19.9585 L2.6912,19.9585 Z M11.1242,0.4795 C11.4752,-0.1595 12.5242,-0.1595 12.8762,0.4795 L12.8762,0.4795 L23.8762,20.4765 C24.0462,20.7865 24.0402,21.1635 23.8602,21.4675 C23.6802,21.7715 23.3532,21.9585 23.0002,21.9585 L23.0002,21.9585 L1.0002,21.9585 C0.6462,21.9585 0.3192,21.7715 0.1392,21.4675 C-0.0408,21.1635 -0.0468,20.7865 0.1242,20.4765 L0.1242,20.4765 Z M11.9998,16.4585 C11.3098,16.4585 10.7498,17.0185 10.7498,17.7085 C10.7498,18.3985 11.3098,18.9585 11.9998,18.9585 C12.6898,18.9585 13.2498,18.3985 13.2498,17.7085 C13.2498,17.0185 12.6898,16.4585 11.9998,16.4585 Z M11.9998,6.7085 C11.4478,6.7085 10.9998,7.1565 10.9998,7.7085 L10.9998,13.7085 C10.9998,14.2605 11.4478,14.7085 11.9998,14.7085 C12.5518,14.7085 12.9998,14.2605 12.9998,13.7085 L12.9998,7.7085 C12.9998,7.1565 12.5518,6.7085 11.9998,6.7085 Z"
}))));
const ErrorMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C23.9807773,5.38056166 18.6194383,0.0192227178 12,0 Z M16.95,15.536 L15.536,16.95 L12,13.414 L8.464,16.95 L7.05,15.536 L10.586,12 L7.05,8.464 L8.464,7.05 L12,10.586 L15.536,7.05 L16.95,8.464 L13.414,12 L16.95,15.536 Z"
})));
const AbstractError = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(ErrorMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(ErrorPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractError);